<cc-nav-bar
    [multiClientApp]="false"
    [appDisplayName]="'Named Query Service'"
    [clientCode]="clientCode"
    [versions]="{ version }"
>
</cc-nav-bar>

<div class="app-content-wrapper">
    <router-outlet></router-outlet>
</div>
